import axios from "axios";
import {
  ACCESS_TOKEN,
  LOGGED_IN,
  REFRESH_TOKEN,
  TOKEN_EXPIRED,
  TOKEN_TYPE,
} from "../lib/const";

function getLocalAccessToken() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  return accessToken;
}

function getLocalRefreshToken() {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  return refreshToken;
}

function refreshToken() {
  const payload = {
    requestObject: {
      refreshToken: getLocalRefreshToken(),
    },
  };

  return axios.post(
    process.env.REACT_APP_GATEWAY_ENDPOINT + "/v1/auth/login",
    JSON.stringify(payload),
    {
      headers: { "Content-Type": "application/json" },
    }
  );
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_GATEWAY_ENDPOINT,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (error) => {
    const originalConfig = error.config;
    if (
      (error.message === "Network Error" ||
        error?.response?.status === 401 ||
        error?.response?.status === 403) &&
      !originalConfig._retry
    ) {
      originalConfig._retry = true;
      try {
        const rs = refreshToken();
        const { objectValue } = rs.data;

        localStorage.setItem(ACCESS_TOKEN, objectValue.accessToken);
        localStorage.setItem(REFRESH_TOKEN, objectValue.refreshToken);
        localStorage.setItem(TOKEN_EXPIRED, objectValue.expiresIn);
        localStorage.setItem(TOKEN_TYPE, objectValue.tokenType);
        localStorage.setItem(LOGGED_IN, true);

        axiosInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${objectValue.accessToken}`;
        axiosInstance.defaults.headers.common["Content-Type"] =
          "application/json";

        return axiosInstance(originalConfig);
      } catch (_error) {
        if (_error.response && _error.response.data) {
          return Promise.reject(_error.response.data);
        }
        return Promise.reject(_error);
      }
    }
    if (error) return Promise.reject(error);
  }
);

export default {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
  patch: axiosInstance.patch,
};
